import TYPES from '@/types';

// Application
import { GetCustomerPersonalInformationQuery }
  from '@/modules/customer/personal-information/application/queries';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';

export default class ChangedDocumentStatusNeedSignatureViewModel {
  @Inject(TYPES.GET_CUSTOMER_PERSONAL_INFORMATION_QUERY)
  private readonly get_customer_personal_information_query!: GetCustomerPersonalInformationQuery;

  @Inject(TYPES.I18N)
  readonly translator!: Translator;

  @Inject(TYPES.NOTIFIER)
  private readonly message_notifier!: MessageNotifier;

  readonly i18n_namespace = 'components.allianz-dashboard.changed-document-status.need-signature';

  user_email = '';

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  initialize = async () => {
    await this.loadUserEmail();
  }

  loadUserEmail = async () => {
    try {
      const { email } = await this.get_customer_personal_information_query.execute();
      this.user_email = email;
    } catch {
      this.message_notifier.showErrorNotification(this.translate('errors.get_customer_personal_information_query'));
    }
  }
}
